var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.detailInfo.length)?_c('c-table',{attrs:{"data":_vm.detailInfo,"tableColumns":_vm.tableColumns}}):_c('div',[_vm._v("暂无申请历史！")])
}
var staticRenderFns = []

export { render, staticRenderFns }